import { useState, useCallback } from "react";

export interface IUseModal {
  visible: boolean;
  show: () => void;
  close: () => void;
  toggle: () => void;
}

/**
 * @deprecated Use import { useToggle } from "usehooks-ts";
 */
export default function useModal(initialVisible: boolean = false): IUseModal {
  const [visible, setVisible] = useState(initialVisible);

  const show = useCallback(() => {
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const toggle = useCallback(() => {
    setVisible((prev) => !prev);
  }, []);

  return {
    visible,
    show,
    close,
    toggle,
  };
}
